module.exports = __webpack_public_path__ + "img/3-2-4.3163ef45.png";